import React  from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 *
 */
const ColorHead = () => {
    const { t } = useTranslation();

    return      <div className="row py-12px d-none d-sm-flex">
        <div className="col-sm-4 d-flex align-items-center fs-14px ibl-font-w-600 font-color-general-950">
            {t("id").toUpperCase()}
        </div>
        <div className="col-sm-3 fs-14px ibl-font-w-600 font-color-general-950">
            {t("background_hex").toUpperCase()}
        </div>
        <div className="col-sm-3 fs-14px ibl-font-w-600 font-color-general-950">
            {t("text_hex").toUpperCase()}
        </div>
        <div className="col-sm-2 d-flex align-items-center fs-14px ibl-font-w-600 font-color-general-950">
            {t("preview").toUpperCase()}
        </div>
    </div>;
};

export default ColorHead;
